var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      width: 256,
      height: 256,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n\t.st0{fill:#4B4B4B;}\n\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.976,241.453c-24.922,8.344-74.078,51.109-84.546,94.672c9.047,2.469,18.828,1.938,27.703,0.25 c-32.297,59.969-85.109,83.391-111.953,91.766c-10.328,3.234-1.719,0.438-1.719,0.438c-3.641,0.922-7.5,0.109-10.469-2.188 s-4.719-5.828-4.75-9.594l-0.031-2.375l-1.906-230.234h43.25c4.078,8.969,13.094,15.219,23.609,15.219 c14.313,0,25.938-11.625,25.938-25.969c0-14.313-11.625-25.938-25.938-25.938c-10.516,0-19.516,6.25-23.609,15.219h-43.422 l-0.422-49.313l-0.016-2.438c-0.031-4.125,2.031-8,5.484-10.297c0,0,2.125-0.797,5.484-3.641 c11.875-10.125,19.422-25.156,19.422-41.938C311.085,24.719,286.367,0,256.007,0c-30.375,0-55.094,24.719-55.094,55.094 c0,16.781,7.547,31.813,19.422,41.938c3.359,2.844,5.484,3.641,5.484,3.641c3.453,2.297,5.516,6.172,5.484,10.297l-0.016,2.438 l-0.406,49.313h-43.438c-4.094-8.969-13.109-15.219-23.594-15.219c-14.344,0-25.953,11.625-25.953,25.938 c0,14.344,11.609,25.969,25.953,25.969c10.5,0,19.5-6.25,23.594-15.219h43.25l-1.906,230.234l-0.016,2.375 c-0.031,3.766-1.797,7.297-4.766,9.594s-6.828,3.109-10.469,2.188c0,0,8.609,2.797-1.719-0.438 c-26.844-8.375-79.656-31.797-111.953-91.766c8.875,1.688,18.656,2.219,27.719-0.25c-10.484-43.563-59.625-86.328-84.547-94.672 c-24.906,28.109-30.016,85.688-12.359,126.859c10.313-4.063,18.938-12.063,25.516-20c10.703,26.813,55.578,118.469,179.703,155.781 c6.484,1.953,13.922,5.563,20.109,7.906c6.172-2.344,13.609-5.953,20.094-7.906c124.125-37.313,169-128.969,179.718-155.781 c6.563,7.938,15.188,15.938,25.5,20C498.976,327.141,493.866,269.563,468.976,241.453z M68.679,329.781 c1.203-2.188,1.828-3.531,1.828-3.531s0.656,0.344,1.813,0.906L68.679,329.781z M256.007,82.094c-14.891,0-27.016-12.109-27.016-27 c0-14.906,12.125-27,27.016-27s27,12.094,27,27C283.007,69.984,270.898,82.094,256.007,82.094z M439.694,327.156 c1.156-0.563,1.797-0.906,1.797-0.906s0.641,1.344,1.828,3.531L439.694,327.156z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor);
export default __webpack_public_path__ + "static/media/anchor.c8f6b31ab9fa23b09400a53e8da67d8d.svg";
export { ForwardRef as ReactComponent };